module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "overflow-hidden",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-card-img', {
    staticClass: "rounded-0",
    attrs: {
      "src": "./static/images/login-background.jpg"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "lg": "6",
      "md": "6",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('b-card-body', {
    attrs: {
      "title": "Hawkeye"
    }
  }, [_c('b-form', {
    on: {
      "submit": _vm.login
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "username-group",
      "label": "Username:",
      "label-for": "username",
      "description": "Default user is admin"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "username",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Enter username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "password-group",
      "label": "Password:",
      "label-for": "password",
      "description": "Default password is 123"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "password",
      "type": "password",
      "required": "",
      "placeholder": "Enter password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("Login")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e59ea270","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/security/LoginPage.vue
// module id = 2151
// module chunks = 1